import React from 'react';

const Buttons = () => {
    return (
        <div className="container-fluid">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1>Buttons UI</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="/">Oculux</a></li>
                                <li className="breadcrumb-item"><a href="/">Components</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Buttons UI</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right hidden-xs">
                        <a href="/" className="btn btn-sm btn-primary mr-1" title="">Create Campaign</a>
                        <a href="https://themeforest.net/item/oculux-bootstrap-4x-admin-dashboard-clean-modern-ui-kit/23091507" className="btn btn-sm btn-success" title="Themeforest"><i className="icon-basket"></i> Buy Now</a>
                    </div>
                </div>
            </div>

            <div className="row clearfix">
                <div className="col-md-12">
                    <div className="card">
                        <div className="body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped table-vcenter mb-0">
                                    <thead>
                                        <tr>
                                            <th className="w-15">Button</th>
                                            <th>className=""</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><button className="btn btn-default btn-block" type="button">Default</button></td>
                                            <td><code>btn btn-default</code></td>
                                            <td>Standard gray button with gradient</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-primary btn-block" type="button">Primary</button></td>
                                            <td><code>btn btn-primary</code></td>
                                            <td>Provides extra visual weight and identifies the primary action in a set of buttons</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-info btn-block" type="button">Info</button></td>
                                            <td><code>btn btn-info</code></td>
                                            <td>Used as an alternative to the default styles</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-success btn-block" type="button">Success</button></td>
                                            <td><code>btn btn-success</code></td>
                                            <td>Indicates a successful or positive action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-warning btn-block" type="button">Warning</button></td>
                                            <td><code>btn btn-warning</code></td>
                                            <td>Indicates caution should be taken with this action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-danger btn-block" type="button">Danger</button></td>
                                            <td><code>btn btn-danger</code></td>
                                            <td>Indicates a dangerous or potentially negative action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-link btn-block" type="button">Link</button></td>
                                            <td><code>btn btn-link</code></td>
                                            <td>Deemphasize a button by making it look like a link while maintaining button behavior</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped table-vcenter mb-0">
                                    <thead>
                                        <tr>
                                            <th className="w-15">Button</th>
                                            <th>className=""</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><button className="btn btn-default btn-block btn-round" type="button">Default</button></td>
                                            <td><code>btn btn-default btn-round</code></td>
                                            <td>Standard gray button with gradient</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-primary btn-block btn-round" type="button">Primary</button></td>
                                            <td><code>btn btn-primary btn-round</code></td>
                                            <td>Provides extra visual weight and identifies the primary action in a set of buttons</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-info btn-block btn-round" type="button">Info</button></td>
                                            <td><code>btn btn-info btn-round</code></td>
                                            <td>Used as an alternative to the default styles</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-success btn-block btn-round" type="button">Success</button></td>
                                            <td><code>btn btn-success btn-round</code></td>
                                            <td>Indicates a successful or positive action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-warning btn-block btn-round" type="button">Warning</button></td>
                                            <td><code>btn btn-warning btn-round</code></td>
                                            <td>Indicates caution should be taken with this action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-danger btn-block btn-round" type="button">Danger</button></td>
                                            <td><code>btn btn-danger btn-round</code></td>
                                            <td>Indicates a dangerous or potentially negative action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-link btn-block btn-round" type="button">Link</button></td>
                                            <td><code>btn btn-link btn-round</code></td>
                                            <td>Deemphasize a button by making it look like a link while maintaining button behavior</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped table-vcenter mb-0">
                                    <thead>
                                        <tr>
                                            <th className="w-15">Button</th>
                                            <th>className=""</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><button className="btn btn-outline-default btn-block" type="button">Default</button></td>
                                            <td><code>btn btn-outline-default</code></td>
                                            <td>Standard gray button with gradient</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-outline-primary btn-block" type="button">Primary</button></td>
                                            <td><code>btn btn-outline-primary</code></td>
                                            <td>Provides extra visual weight and identifies the primary action in a set of buttons</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-outline-info btn-block" type="button">Info</button></td>
                                            <td><code>btn btn-outline-info</code></td>
                                            <td>Used as an alternative to the default styles</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-outline-success btn-block" type="button">Success</button></td>
                                            <td><code>btn btn-outline-success</code></td>
                                            <td>Indicates a successful or positive action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-outline-warning btn-block" type="button">Warning</button></td>
                                            <td><code>btn btn-outline-warning</code></td>
                                            <td>Indicates caution should be taken with this action</td>
                                        </tr>
                                        <tr>
                                            <td><button className="btn btn-outline-danger btn-block" type="button">Danger</button></td>
                                            <td><code>btn btn-outline-danger</code></td>
                                            <td>Indicates a dangerous or potentially negative action</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="body">
                            <h6>Disabled State</h6>
                            <div className="row clearfix">
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-primary .disabled</code><br />
                                        <button type="button" className="btn btn-primary disabled">Primary</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-default .disabled</code><br />
                                        <button type="button" className="btn btn-default disabled">Secondary</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-success .disabled</code><br />
                                        <button type="button" className="btn btn-success disabled">Success</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-danger .disabled</code><br />
                                        <button type="button" className="btn btn-danger disabled">Danger</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-warning .disabled</code><br />
                                        <button type="button" className="btn btn-warning disabled">Warning</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-info .disabled</code><br />
                                        <button type="button" className="btn btn-info disabled">Info</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-light .disabled</code><br />
                                        <button type="button" className="btn btn-light disabled">Light</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-dark .disabled</code><br />
                                        <button type="button" className="btn btn-dark disabled">Dark</button>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-12">
                                    <div className="mb-2">
                                        <code>.btn .btn-link .disabled</code><br />
                                        <button type="button" className="btn btn-link disabled">Link</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row clearfix">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="header">
                            <h2>Button tags</h2>
                        </div>
                        <div className="body">
                            <a className="btn btn-primary mr-1" href="/" role="button">Link</a>
                            <button className="btn btn-primary mr-1" type="submit">Button</button>
                            <input className="btn btn-primary mr-1" type="button" value="Input" />
                            <input className="btn btn-primary mr-1" type="submit" value="Submit" />
                            <input className="btn btn-primary mr-1" type="reset" value="Reset" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row clearfix">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="header">
                            <h2>Button group</h2>
                        </div>
                        <div className="body">
                            <div className="row clearfix">
                                <div className="col-lg-4 col-md-12">
                                    <h6>Button toolbar</h6>
                                    <div className="btn-toolbar mb-3">
                                        <div className="btn-group mr-2">
                                            <button type="button" className="btn btn-default">1</button>
                                            <button type="button" className="btn btn-default">2</button>
                                            <button type="button" className="btn btn-default">3</button>
                                        </div>
                                        <div className="btn-group mr-2">
                                            <button type="button" className="btn btn-default">4</button>
                                            <button type="button" className="btn btn-default">5</button>
                                            <button type="button" className="btn btn-default">6</button>
                                        </div>
                                        <div className="btn-group" role="group" aria-label="Third group">
                                            <button type="button" className="btn btn-default">8</button>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="btn-toolbar mb-3">
                                        <div className="btn-group mr-2">
                                            <button type="button" className="btn btn-default">1</button>
                                            <button type="button" className="btn btn-default">2</button>
                                        </div>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <div className="input-group-text" id="btnGroupAddon">@</div>
                                            </div>
                                            <input type="text" className="form-control" placeholder="Input group example" aria-label="Input group example" aria-describedby="btnGroupAddon" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <h6>Nesting</h6>
                                    <div className="btn-group mb-3">
                                        <button type="button" className="btn btn-default">1</button>
                                        <button type="button" className="btn btn-default">2</button>

                                        <div className="btn-group" role="group">
                                            <button id="btnGroupDrop1" type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Dropdown
                                        </button>
                                            <div className="dropdown-menu">
                                                <a className="dropdown-item" href="/">Dropdown link</a>
                                                <a className="dropdown-item" href="/">Dropdown link</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <h6>Different Sizing</h6>
                                    <div className="btn-group btn-group-lg">
                                        <button type="button" className="btn btn-default">Left</button>
                                        <button type="button" className="btn btn-default">Middle</button>
                                        <button type="button" className="btn btn-default">Right</button>
                                    </div>
                                    <br /><br />
                                    <div className="btn-group btn-group-sm">
                                        <button type="button" className="btn btn-default">Left</button>
                                        <button type="button" className="btn btn-default">Middle</button>
                                        <button type="button" className="btn btn-default">Right</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="body">
                            <button type="button" className="btn btn-default mb-2 mr-1"><i className="fa fa-plus-square"></i> <span>Default</span></button>
                            <button type="button" className="btn btn-primary mb-2 mr-1"><i className="fa fa-refresh"></i> <span>Primary</span></button>
                            <button type="button" className="btn btn-info mb-2 mr-1"><i className="fa fa-info-circle"></i> <span>Info</span></button>
                            <button type="button" className="btn btn-primary mb-2 mr-1" disabled="disabled"><i className="fa fa-refresh fa-spin"></i> <span>Refreshing...</span></button>
                            <button type="button" className="btn btn-success mb-2 mr-1"><i className="fa fa-check-circle"></i> <span>Success</span></button>
                            <button type="button" className="btn btn-warning mb-2 mr-1"><i className="fa fa-warning"></i> <span>Warning</span></button>
                            <button type="button" className="btn btn-danger mb-2 mr-1"><i className="fa fa-trash-o"></i> <span>Danger</span></button>
                            <button type="button" className="btn btn-primary mb-2 mr-1" disabled="disabled"><i className="fa fa-spinner fa-spin"></i> <span>Loading...</span></button>
                            <button type="button" className="btn btn-danger mb-2 mr-1"><i className="fa fa-heart"></i> <span>Love</span></button>
                            <button type="button" className="btn btn-danger mb-2 mr-1"><span>Love</span> <i className="fa fa-heart"></i></button>
                            <button type="button" className="btn btn-danger mb-2 mr-1"><span className="sr-only">Love</span> <i className="fa fa-heart"></i></button>
                            <button type="button" className="btn btn-default mb-2 mr-1" title="Refresh"><span className="sr-only">Refresh</span> <i className="fa fa-refresh"></i></button>
                            <button type="button" className="btn btn-default mb-2 mr-1" title="Copy"><span className="sr-only">Copy</span> <i className="fa fa-files-o"></i></button>
                            <button type="button" className="btn btn-success mb-2 mr-1" title="Save"><span className="sr-only">Save</span> <i className="fa fa-save"></i></button>
                            <button type="button" className="btn btn-danger mb-2 mr-1" title="Delete"><span className="sr-only">Delete</span> <i className="fa fa-trash-o"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default Buttons
